module.exports = __webpack_public_path__ + "media/country_flags/dj-f7270b8a.png";